/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './initAgeAssurance.defs'
export { main as default } from './initAgeAssurance.defs'
